export default __webpack_public_path__ + "static/portfolio-032b95676584d6ba1a892f5490bea6aa.jpg";